import { render, staticRenderFns } from "./WorkshopTypeList.vue?vue&type=template&id=6cf58a9b"
import script from "./WorkshopTypeList.vue?vue&type=script&lang=js"
export * from "./WorkshopTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports